module.exports = __webpack_public_path__ + "img/img1.8dcc421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceRules/img1.png
// module id = 423
// module chunks = 0